// مسئول مکان — place: ردیف مکان از صفحهٔ اماکن
import React, { useState, useEffect, useCallback } from 'react';
import ListPage, { ui } from '../../components/ListPage';
import { ExcelButton } from '../../components/excel';
import WarningDialog from '../../components/WarningDialog';
import JalaliDatePicker from '../../components/JalaliDatePicker';
import { useFormButtons } from '../../utils/vbPerms';
import { API, Grid, Lookup, Box, MessageBox, Modal, splitLines, DEL_ASK } from './placeShared';

const FORM = 'FRMPLACEPEOPLE';
const BUTTONS = ['BTNNEW', 'BTNEDIT', 'BTNDELETE', 'BTNOK', 'BTNCANCEL'];
const COLS = [{ key: 'event_date', label: 'تاریخ' }, { key: 'responsible', label: 'مسئول', wrap: true }];
const EMPTY = { people_id: 0, responsible: '', event_date: '' };

export default function PlacePeople({ user, onBack, place }) {
  const fb = useFormButtons(FORM, BUTTONS);
  const [rows, setRows] = useState([]);
  const [sel, setSel] = useState(null);
  const [modal, setModal] = useState(null);
  const [form, setForm] = useState(EMPTY);
  const [err, setErr] = useState('');
  const [msg, setMsg] = useState(null);
  const [ask, setAsk] = useState(null);
  const pid = place ? place.id : 0;

  const load = useCallback((keepId) => {
    API(`/${pid}/place-people/`).then(j => {
      const d = j.ok ? j.data : [];
      setRows(d);
      setSel((keepId && d.find(r => r.id === keepId)) || d[0] || null);
      if (!j.ok) setErr(j.msg);
    });
  }, [pid]);
  useEffect(() => { if (fb.open) load(); }, [fb.open, load]);

  const openNew = () => { setForm(EMPTY); setErr(''); setModal('new'); };
  const openEdit = () => { if (!sel) return; setForm({ people_id: sel.people_id, responsible: sel.responsible, event_date: sel.event_date }); setErr(''); setModal('edit'); };
  const save = async () => {
    const body = JSON.stringify({ ...form, place_id: pid });
    const j = modal === 'new' ? await API('/place-people/create/', { method: 'POST', body })
      : await API(`/place-people/${sel.id}/update/`, { method: 'PUT', body });
    if (j.ok) { setModal(null); load(j.id); } else setErr(j.msg);
  };
  const doDelete = async () => {
    setAsk(null);
    const j = await API(`/place-people/${sel.id}/delete/`, { method: 'DELETE' });
    if (j.ok) load(); else setMsg(splitLines(j.msg));
  };
  const askDelete = async () => {
    if (!sel) return;
    const j = await API(`/place-people/${sel.id}/delete/?check=1`, { method: 'DELETE' });
    if (!j.ok) { setMsg(splitLines(j.msg)); return; }
    setAsk({ lines: [DEL_ASK] });
  };

  const has = !!sel;
  const toolbar = fb.open ? (
    <>
      <div style={ui.toolBtns}>
        {fb.can('BTNNEW') && <button onClick={openNew} style={{ ...ui.btnNew, cursor: 'pointer' }}>＋ جدید</button>}
        {fb.can('BTNEDIT') && <button onClick={openEdit} disabled={!has} style={{ ...ui.btnEdit, opacity: has ? 1 : 0.4, cursor: 'pointer' }}>✎ ویرایش</button>}
        {fb.can('BTNDELETE') && <button onClick={askDelete} disabled={!has} style={{ ...ui.btnDel, opacity: has ? 1 : 0.4, cursor: 'pointer' }}>✕ حذف</button>}
      </div>
      <ExcelButton title="مسئول مکان" subtitle={place ? place.place_name : ''} columns={COLS} rows={rows} />
    </>
  ) : null;

  return (
    <>
      <ListPage user={user} onBack={onBack} title="مسئول مکان" subtitle={place ? place.place_name : ''} toolbar={toolbar}>
        {fb.open && <Grid columns={COLS} rows={rows} selectedId={sel && sel.id} onSelect={setSel} />}
      </ListPage>
      {modal && (
        <Modal title="مسئول مکان" onClose={() => setModal(null)}
          footer={<>
            {fb.can('BTNCANCEL') && <button onClick={() => setModal(null)} style={ui.btnCancel}>لغو</button>}
            {fb.can('BTNOK') && <button onClick={save} style={ui.btnSave}>ثبت</button>}
          </>}>
          {err && <div style={ui.errBox}>⚠️ {err}</div>}
          <div style={ui.row}>
            <Lookup label="مسئول" value={form.responsible} endpoint="/place-people/lookup/people/"
              onPick={r => setForm(f => ({ ...f, people_id: r.id, responsible: r.title }))} flex={2} />
            <Box label="تاریخ">
              <JalaliDatePicker value={form.event_date} onChange={v => setForm(f => ({ ...f, event_date: v }))} />
            </Box>
          </div>
        </Modal>
      )}
      {ask && <WarningDialog title="هشدار" lines={ask.lines} confirmLabel="بلی" cancelLabel="خیر" tone="danger"
        onConfirm={doDelete} onCancel={() => setAsk(null)} />}
      {msg && <MessageBox lines={msg} onClose={() => setMsg(null)} />}
    </>
  );
}
